import { Observable } from "rxjs";
import { CapaToken } from "../../../../infraestructure/response-model/geosura/capa-token.response";
import { Token } from "../../../../infraestructure/response-model/geosura/token.response";
import { DireccionRequest } from "../../maestro/entity/direccion-request";
export abstract class UbicacionGateway {
    abstract getTokenGeosura(address: DireccionRequest): Observable<Token>;

    abstract getMapaGeosura(token: string): string;

    abstract getCoorsByToken(token: string): Observable<CapaToken>;
}
